import { builder } from '@builder.io/react'

import store from 'base/store'
import Event from 'base/event'
import Hub from 'base/hub'

export default function setupBuilder() {
  if (!store.getState().appConfig.isProductionLike) {
    return
  }

  Hub.sub(
    Event.Checkout.ADD_TO_CART,
    (event, { variant }) => {
      builder.track('addToCart', {
        meta: {
          productId: variant.product_id,
          productName: variant.display_name,
        },
      })
    },
    { late: true },
  )

  Hub.sub(
    Event.Checkout.COMPLETE,
    (event, order) => {
      builder.trackConversion(order.total_in_usd)
    },
    { late: true },
  )
}
